import React, { Component } from "react";


class PearlTerrain extends Component{

    render(){
        return (
           
                     <div >
                            {this.props.body}
                           
                        </div>
        )
                
             
    }
}


export default PearlTerrain;